import React from 'react';
import { ACCENT_CLASSES, AccentColor } from '../../types/work';

interface Props {
  pct: number;
  accent?: AccentColor;
  showLabel?: boolean;
  shimmer?: boolean;
}

export const ProgressBar: React.FC<Props> = ({ pct, accent = 'emerald', showLabel = true, shimmer = false }) => {
  const clamped = Math.min(100, Math.max(0, pct));
  const colors = ACCENT_CLASSES[accent];
  return (
    <div className="flex items-center gap-2">
      <div className={`flex-1 h-1.5 rounded-full ${colors.bg} overflow-hidden`}>
        <div
          className={`h-full rounded-full ${colors.fill} transition-all duration-700 ${shimmer ? 'animate-pulse' : ''}`}
          style={{ width: `${clamped}%` }}
        />
      </div>
      {showLabel && <span className="text-xs text-gray-500 w-8 text-right">{Math.round(clamped)}%</span>}
    </div>
  );
};
